export default {
  // https://www.hongkongfp.com/2018/02/05/mobile-phone-numbers-starting-4-7-8-soon-available-hong-kong/
  // https://news.mydrivers.com/1/496/496684.htm
  // https://regex101.com/r/XivcqJ/3
  MOBILE_REGEX: /^(\+852|\+853)?[4-9][0-9]{7}$|^(\+86)?1[0-9]{10}$/,
  OTP_REGEX: /^[0-9]{6,}$/,
  TOKEN_REGEX: /^[A-Z0-9]{20}$/,
  CODE_REGEX: /^[A-Z0-9]{6}$/
};
